import {ISSUE_TYPE_MILESTONE, ISSUE_TYPE_PUBLIC_HOLIDAY, ISSUE_TYPE_VACATION} from "../../../constants";

/**
 * Resolves which of the 8 fully-enumerated i18n keys under
 * ha-boards-view.edit-issue.header.* applies for the given mode + root. The
 * caller passes the ROOT uid of the issue's type (rootUidOf), so a child gets
 * its root's header (an Absence child: "Abwesenheit bearbeiten"). Never
 * composes a key from an unbounded value (e.g. a custom type's shortcut) — every
 * possible return value is one of the 8 literal keys already registered in
 * de.json, so the Translation Editor (which only manages keys that already exist
 * as literal entries, no source scanner) can always find and manage them. Any
 * type that isn't vacation/public-holiday/milestone (custom tenant types, TODO,
 * timeframe) falls back to the generic "default"/"create" key. The dedicated
 * "new vacation"/"new public holiday"/"new milestone" entry points set a known,
 * fixed type before the dialog opens, so they get a matching title.
 */
export function resolveIssueDialogTitleKey(isCreating: boolean, rootUid: string | null | undefined): string {
    if (isCreating) {
        if (rootUid === ISSUE_TYPE_VACATION) return 'ha-boards-view.edit-issue.header.create-absence';
        if (rootUid === ISSUE_TYPE_PUBLIC_HOLIDAY) return 'ha-boards-view.edit-issue.header.create-public-holiday';
        if (rootUid === ISSUE_TYPE_MILESTONE) return 'ha-boards-view.edit-issue.header.create-milestone';
        return 'ha-boards-view.edit-issue.header.create';
    }

    if (rootUid === ISSUE_TYPE_VACATION) return 'ha-boards-view.edit-issue.header.absence';
    if (rootUid === ISSUE_TYPE_PUBLIC_HOLIDAY) return 'ha-boards-view.edit-issue.header.public-holiday';
    if (rootUid === ISSUE_TYPE_MILESTONE) return 'ha-boards-view.edit-issue.header.milestone';
    return 'ha-boards-view.edit-issue.header.default';
}
